import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import {METHOD_POST} from '@constants/http';
import type {GetFullContentResponse} from '@interfaces/PreviewWidget';
import type ValueList from '@interfaces/ValueList';

export async function getFullContent(params: ValueList = {}): Promise<GetFullContentResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/preview/full`)
        .setParams(params)
        .send()) as Promise<GetFullContentResponse>;
}

export async function subscribeAndGetFullContent(
    code: string,
    email: string,
): Promise<GetFullContentResponse> {
    return (await new RequestClass(
        `${API_NAMESPACE}/preview/subscriber/${code}/subscribe`,
        METHOD_POST,
    )
        .setParams({email})
        .send()) as Promise<GetFullContentResponse>;
}
